module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_german_sm-5f42ec1e07d5bebb81fed8391c62ef3b.png";